import React from 'react';
import cx from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import ProtectedComponent from './ProtectedComponent';
import Logo from './Logo';
import AccountNav from './AccountNav';
import NavLink from './NavLink';
import { IndexLink } from 'react-router';
import Roles from '../constants/Roles';
import RequiresActiveSubscription from './RequiresActiveSubscription';

const messages = defineMessages({
  analytics: {
    id: 'section.analytics',
    defaultMessage: 'Analytics',
    description: 'The button text for the Analytics link.'
  },
  compliance: {
    id: 'section.compliance',
    defaultMessage: 'Compliance',
    description: 'The button text for the Compliance link.'
  },
  login: {
    id: 'section.account.login',
    defaultMessage: 'login',
    description: 'The button text for the login link.'
  },
  userManagement: {
    id: 'section.userManagement',
    defaultMessage: 'Users',
    description: 'The button text for the user management.'
  },
  audit: {
    id: 'section.audit',
    defaultMessage: 'Audit',
    description: 'The button text for the audit link.'
  }
});

function renderAccountNav() {
  return <AccountNav />;
}

const NavBar = () => {
  const linkClasses = cx({
    'navbar-link': true,
    'flex-container': true,
    'flex-vertical': true
  });

  return (
    <nav className="navbar flex-container">
      <div className="navbar-title">
        <IndexLink to="/" className="navbar-home navbar-link flex-container flex-vertical">
          <div className="logo-wrapper">
            <Logo/>
          </div>
        </IndexLink>
      </div>
      <div className="navbar-links flex-element flex-container">
        <RequiresActiveSubscription>
          <ProtectedComponent role={Roles.ANALYTICS_DASHBOARD}>
            <NavLink to="/analytics" className={ linkClasses }>
              <FormattedMessage { ...messages.analytics } />
            </NavLink>
          </ProtectedComponent>
        </RequiresActiveSubscription>
        <RequiresActiveSubscription>
          <ProtectedComponent role={Roles.COMPLIANCE_DASHBOARD}>
            <NavLink to="/compliance" className={ linkClasses }>
              <FormattedMessage { ...messages.compliance } />
            </NavLink>
          </ProtectedComponent>
        </RequiresActiveSubscription>
        <ProtectedComponent role={Roles.USER_MANAGER}>
          <NavLink to="/user-management" className={ linkClasses }>
            <FormattedMessage { ...messages.userManagement } />
          </NavLink>
        </ProtectedComponent>
        <ProtectedComponent role={Roles.AUDIT}>
          <NavLink to="/audit" className={ linkClasses }>
            <FormattedMessage { ...messages.audit } />
          </NavLink>
        </ProtectedComponent>
      </div>
      <div className="navbar-account flex-container">
        <ProtectedComponent hideWhenAuthenticated alternateComponent={ renderAccountNav }>
          <NavLink to="/account/login" className={ linkClasses }>
            <FormattedMessage { ...messages.login } />
          </NavLink>
        </ProtectedComponent>
      </div>
    </nav>
  );
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js